import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendJobForm, resetJobFormState } from "../../redux/JobFormSlice";
import "./JobForm.css";
import CheckEmpty from "../../Assets/Svg/Jobs/CheckEmpty.svg";
import CheckFilled from "../../Assets/Svg/Jobs/CheckFill.svg";
export default function JobsFormAr() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.jobForm);
  const formRef = useRef();
  const [captcha, setCaptcha] = useState("");
  const [userCaptchaInput, setUserCaptchaInput] = useState("");
  const [isCaptchaOpen, setIsCaptchaOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [agreeTerms1, setAgreeTerms1] = useState(false);
  const [agreeTerms2, setAgreeTerms2] = useState(false);
  const [uploadedCV, setUploadedCV] = useState(null);
  const [uploadedCoverLetter, setUploadedCoverLetter] = useState(null);
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  useEffect(() => {
    generateCaptcha();
    dispatch(resetJobFormState());
  }, [dispatch]);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10);
    const num2 = Math.floor(Math.random() * 10);
    setCaptcha(`${num1} + ${num2}`);
  };

  const validateName = (value) => {
    if (value.trim().length < 3) {
      setNameError("يجب أن يتكون الاسم من 3 أحرف على الأقل.");
    } else {
      setNameError("");
    }
  };

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value.trim())) {
      setEmailError("يرجى إدخال عنوان بريد إلكتروني صالح .");
    } else {
      setEmailError("");
    }
  };
  const validatePhone = (value) => {
    if (value.trim().length < 11) {
      setPhoneError("أدخل رقم هاتف صالحًا .");
    } else {
      setPhoneError("");
    }
  };
  //

  const validateInputs = (formData, updatedAgreeTerms1 = agreeTerms1, updatedAgreeTerms2 = agreeTerms2) => {
    const name = formData.get("user_name").trim();
    const email = formData.get("user_email").trim();
    const phone = formData.get("user_phone").trim();

    return (
      name.length >= 3 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && phone.length >= 3 && updatedAgreeTerms1 && updatedAgreeTerms2 && uploadedCV // Resume/CV is required
    );
  };

  const handleFileChangeCv = (e) => {
    const file = e.target.files[0];
    if (file && file.size < 2 * 1024 * 1024) {
      setUploadedCV(file);
    } else {
      alert("File is too large or not valid.");
    }
  };

  const handleFileChangeLetterFile = (e) => {
    const file = e.target.files[0];
    if (file && file.size < 2 * 1024 * 1024) {
      setUploadedCoverLetter(file);
    } else {
      alert("File is too large or not valid.");
    }
  };

  const sendEmailAfterVerification = (e) => {
    e.preventDefault();
    const form = formRef.current;
    if (!form) return;

    const formData = new FormData(form);
    if (!validateInputs(formData)) return;

    setIsCaptchaOpen(true);
  };

  const verifyCaptchaAndSendEmail = async () => {
    const captchaValues = captcha.split(" + ").map(Number);
    const correctCaptchaAnswer = captchaValues[0] + captchaValues[1];

    if (parseInt(userCaptchaInput) !== correctCaptchaAnswer) {
      alert("Captcha verification failed. Please try again.");
      return;
    }

    try {
      const form = formRef.current;
      const formData = new FormData(form);

      const payload = {
        name: formData.get("user_name"),
        email: formData.get("user_email"),
        phone: formData.get("user_phone"),
        address: formData.get("user_address"),
        message: formData.get("user_message"),
        position_id: 1,
        resume: null,
        cover_letter: null,
      };

      if (uploadedCV) {
        payload.resume = ("resume", uploadedCV);
      }

      if (uploadedCoverLetter) {
        payload.cover_letter = ("cover_letter", uploadedCoverLetter);
      }

      await dispatch(sendJobForm(payload)).unwrap();
      setIsSuccess(true);
      setUserCaptchaInput("");
      setCaptcha("");
      setUploadedCV(null);
      setUploadedCoverLetter(null);
      setIsFormValid(false);
      form.reset();
      generateCaptcha();
    } catch (err) {
      console.error("Form submission failed:", err);
      if (typeof err === "object" && err.errors) {
        const allErrors = Object.values(err.errors).flat().join("\n");
        alert(allErrors);
      } else {
        alert("Something went wrong. Please try again.");
      }
    }
  };

  const checkFormValidity = () => {
    const form = formRef.current;
    if (!form) return false;

    const formData = new FormData(form);
    setIsFormValid(validateInputs(formData));
  };

  const toggleAgreeTerms1 = () => {
    setAgreeTerms1((prev) => {
      const newState = !prev;
      // Call checkFormValidity with the updated state
      checkFormValidityWithUpdatedTerms(newState, agreeTerms2);
      return newState;
    });
  };
  const toggleAgreeTerms2 = () => {
    setAgreeTerms2((prev) => {
      const newState = !prev;
      // Call checkFormValidity with the updated state
      checkFormValidityWithUpdatedTerms(agreeTerms1, newState);
      return newState;
    });
  };

  const checkFormValidityWithUpdatedTerms = (updatedAgreeTerms1, updatedAgreeTerms2) => {
    const form = formRef.current;
    if (!form) return;

    const formData = new FormData(form);
    setIsFormValid(validateInputs(formData, updatedAgreeTerms1, updatedAgreeTerms2));
  };

  const enforceWordLimit = (event, maxWords) => {
    const textarea = event.target;
    const words = textarea.value.trim().split(/\s+/);
    if (words.length > maxWords) {
      textarea.value = words.slice(0, maxWords).join(" ");
      alert(`You can only enter up to ${maxWords} words.`);
    }
  };

  return (
    <>
      <div className="JobsS5">
        <form ref={formRef} onSubmit={sendEmailAfterVerification} onChange={checkFormValidity}>
          <div className="ContactUsBig">
            <div className="JobFormWebContainer ar">
              <div className="JobFormWTC ar">
                <div className="JobFormWP1">
                  <div className="FiledBoxContainer">
                    <InputFieldBoxAr
                      InputType="input"
                      Type="text"
                      Name="الاسم الكامل"
                      name="user_name"
                      Required="(مطلوب)"
                      Placeholder="الاسم"
                      Height=""
                      InputWidth="34.5vw"
                      onBlur={(e) => validateName(e.target.value)}
                    />
                    {nameError && (
                      <div className="error-message_Ar TF16PxSC" dir="rtl">
                        {nameError}
                      </div>
                    )}
                  </div>
                  <div className="FiledBoxContainer">
                    <InputFieldBoxAr
                      InputType="input"
                      Type="text"
                      Name="البريد الإلكتروني"
                      name="user_email"
                      Required="(مطلوب)"
                      Placeholder="example@gmail.com"
                      Height=""
                      InputWidth="34.5vw"
                      onBlur={(e) => validateEmail(e.target.value)}
                    />
                    {emailError && (
                      <div className="error-message_Ar TF16PxSC" dir="rtl">
                        {emailError}
                      </div>
                    )}
                  </div>

                  <div className="FiledBoxContainer">
                    <InputFieldBoxAr
                      InputType="input"
                      Type="text"
                      Name="رقم الهاتف"
                      name="user_phone"
                      Required="(مطلوب)"
                      Placeholder="+20"
                      Height=""
                      InputWidth="34.5vw"
                      onBlur={(e) => validatePhone(e.target.value)}
                    />
                    {phoneError && (
                      <div className="error-message_Ar TF16PxSC" dir="rtl">
                        {phoneError}
                      </div>
                    )}
                  </div>
                  <InputFieldBoxAr
                    InputType="input"
                    Type="text"
                    Name="العنوان"
                    name="user_address"
                    Required="(اختياري)"
                    Placeholder="عنوانك بالتفصيل المدينة، الشارع، المبنى، الخ"
                    Height=""
                    InputWidth="34.5vw"
                  />
                </div>
                <div className="FormWP1">
                  <InputFieldBoxUploadCV
                    InputType="input"
                    Type="text"
                    Name="السيرة الذاتية"
                    name="resume"
                    Required="(تحميل الملف، بصيغة PDF/Word)"
                    Placeholder="الحد الأقصى للحجم هو 2 ميجا بايت"
                    InputWithButton={true}
                    InputWidth="25vw"
                    ButtonText="إختيار ملف"
                    onFileChange={(e) => handleFileChangeCv(e, "cv")}
                    fileName={uploadedCV?.name}
                  />
                  <InputFieldBoxUploadCL
                    InputType="input"
                    Type="text"
                    Name="تحميل خطاب التقديم"
                    name="cover_letter"
                    Required="(اختياري)"
                    Placeholder="الحد الأقصى للحجم هو 2 ميجا بايت"
                    InputWithButton={true}
                    InputWidth="25vw"
                    ButtonText="إختيار ملف"
                    onFileChange={(e) => handleFileChangeLetterFile(e, "coverLetter")}
                    fileName={uploadedCoverLetter?.name}
                  />
                  <InputFieldBoxAr
                    InputType="textarea"
                    Type="text"
                    Name="رسالتك"
                    name="user_message"
                    Required="(اختياري)"
                    Placeholder="رسالتك لنا، بما في ذلك أي تفاصيل أو أسئلة"
                    onInput={(e) => enforceWordLimit(e, 1000)}
                    maxLength={1000}
                    TextAreaHeight="12.3vw"
                  />
                </div>
              </div>
              <div className="JobTerms ar">
                <div className="JobTermsP1 ar TFut24PxPC">اتفاق</div>
                <div className="JobTermsP2 ar TFut20PxPC">
                  <button type="button" onClick={toggleAgreeTerms1}>
                    <img src={agreeTerms1 ? CheckFilled : CheckEmpty} alt="checkbox" className="CheckFilledImg" />
                  </button>
                  أوافق على الشروط والأحكام
                </div>
                <div className="JobTermsP2 ar TFut20PxPC">
                  <button type="button" onClick={toggleAgreeTerms2}>
                    <img src={agreeTerms2 ? CheckFilled : CheckEmpty} alt="checkbox" className="CheckFilledImg" />
                  </button>
                  أوافق على استخدام بياناتي لأغراض التوظيف
                </div>
              </div>
            </div>
            {/*  */}
            {/*  */}
            {/* Captcha Pop-up */}
            {isCaptchaOpen && (
              <CaptchaModal
                captcha={captcha}
                userCaptchaInput={userCaptchaInput}
                setUserCaptchaInput={setUserCaptchaInput}
                onCancel={() => {
                  setIsCaptchaOpen(false);
                  setUserCaptchaInput("");
                  generateCaptcha();
                }}
                onVerify={verifyCaptchaAndSendEmail}
                isLoading={loading}
                isSuccess={isSuccess}
              />
            )}
            {/*  */}
            {/*  */}
          </div>
          <div className="JobsS6 ar">
            <div className="JobsS6P1 ar TF20PxSC" dir="rtl">
              لتقديم طلب وظيفة قم بملء نموذج الطلب .
            </div>
            <div className="JobsS6P2">
              <button
                className="JobFromWsubmitB ar TFut16PxPCUC"
                type="submit"
                style={{ opacity: isFormValid ? 1 : 0.2, cursor: isFormValid ? "pointer" : "not-allowed" }}
                disabled={loading}
              >
                تقديم
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

function InputFieldBoxAr({
  InputType,
  InputWidth,
  InputWidthMob,
  TextAreaHeight,
  TextAreaHeightMob,
  InputWithButton,
  Type,
  Name,
  Required,
  Placeholder,
  name,
  ButtonText,
  onFileChange,
  onBlur,
}) {
  const isMobile = window.innerWidth <= 768;
  const fileInputRef = useRef();

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="JobInputFieldBox ar">
      <div className="JobIFBT ar">
        <div className="JobIFBTN ar TFut24PxPC">{Name}</div>
        <div className="JobIFBTR ar TFut16PxPCUC">{Required}</div>
      </div>
      <div className="JobIFBContent">
        <InputType
          type={Type}
          name={name}
          placeholder={Placeholder}
          className="JobIFBI ar TFut20PxPC"
          style={{ width: isMobile ? InputWidthMob : InputWidth, height: isMobile ? TextAreaHeightMob : TextAreaHeight }}
          onBlur={onBlur}
        />
        {InputWithButton && (
          <>
            <button type="button" className="JobIFBButton TFut16PxPCUC" onClick={handleButtonClick}>
              {ButtonText}
            </button>
            <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={onFileChange} accept=".pdf,.doc,.docx" />
          </>
        )}
      </div>
    </div>
  );
}
function InputFieldBoxUploadCV({
  InputType,
  InputWidth,
  InputWidthMob,
  TextAreaHeight,
  TextAreaHeightMob,
  InputWithButton,
  Type,
  Name,
  Required,
  Placeholder,
  name,
  ButtonText,
  onFileChange,
  fileName,
}) {
  const fileInputRef = useRef();
  const isMobile = window.innerWidth <= 768;

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="JobInputFieldBoxCV ar">
      <div className="JobIFBT ar">
        <div className="JobIFBTN ar TFut24PxPC" dir="rtl">
          {Name}
        </div>
        <div className="JobIFBTR ar TFut16PxPCUC" dir="rtl">
          {Required}
        </div>
      </div>
      <div className="JobIFBContent ar">
        <InputType
          type="text"
          name={name}
          placeholder={Placeholder}
          className="JobIFBI ar TFut20PxPC"
          style={{ width: isMobile ? InputWidthMob : InputWidth, height: isMobile ? TextAreaHeightMob : TextAreaHeight }}
          value={fileName || ""}
          readOnly={InputWithButton}
        />
        {InputWithButton && (
          <>
            <button type="button" className="JobIFBButton ar TFut16PxPCUC" onClick={handleButtonClick}>
              {ButtonText}
            </button>
            <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={onFileChange} accept=".pdf,.doc,.docx" />
          </>
        )}
      </div>
    </div>
  );
}
function InputFieldBoxUploadCL({
  InputType,
  InputWidth,
  InputWidthMob,
  TextAreaHeight,
  TextAreaHeightMob,
  InputWithButton,
  Type,
  Name,
  Required,
  Placeholder,
  name,
  ButtonText,
  onFileChange,
  fileName,
}) {
  const fileInputRef = useRef();
  const isMobile = window.innerWidth <= 768;

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="JobInputFieldBoxL ar">
      <div className="JobIFBT ar">
        <div className="JobIFBTN ar TFut24PxPC">{Name}</div>
        <div className="JobIFBTR ar TFut16PxPCUC">{Required}</div>
      </div>
      <div className="JobIFBContent ar">
        <InputType
          type="text"
          name={name}
          placeholder={Placeholder}
          className="JobIFBI ar TFut20PxPC"
          style={{ width: isMobile ? InputWidthMob : InputWidth, height: isMobile ? TextAreaHeightMob : TextAreaHeight }}
          value={fileName || ""}
          readOnly={InputWithButton}
        />
        {InputWithButton && (
          <>
            <button type="button" className="JobIFBButton ar TFut16PxPCUC" onClick={handleButtonClick}>
              {ButtonText}
            </button>
            <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={onFileChange} accept=".pdf,.doc,.docx" />
          </>
        )}
      </div>
    </div>
  );
}

function CaptchaModal({ captcha, userCaptchaInput, setUserCaptchaInput, onVerify, onCancel, isLoading, isSuccess }) {
  return (
    <div className="captchaModal">
      <div className="captchaModalContent">
        {isLoading ? (
          <div className="CPLoading ar TFut16PxPCUC">يرجى الإنتظار</div>
        ) : isSuccess ? (
          <div className="CaptchaSubmit">
            <div className="CPMessage ar TFut16PxPCUC" dir="rtl">
              شكرًا لك<span className="SpanBigger">,</span> لقد تم إرسال بريدك الإلكتروني<span className="SpanBigger">,</span>وسيتصل بك أحد أعضاء فريقنا قريبًا
              .
            </div>
            <button onClick={onCancel} className="CaptchaSubB ar TFut16PxPCUC">
              إنهاء
            </button>
          </div>
        ) : (
          <div className="CaptchaQAContainer">
            <div className="CaptchaQ">
              <div className="CaptchaQP1 ar TGLo32PxPC">التحقق البشري</div>
              <div className="CaptchaQP2 ar TFut16PxPCUC" dir="rtl">
                يرجى حل المسألة الرياضية أدناه للمتابعة: ما هو جمع <span></span>
                {captcha} ؟
              </div>
            </div>
            <div className="CaptchaAA">
              <input
                type="text"
                className="CaptchaAnswerF TFut16PxPCUC"
                placeholder="_"
                value={userCaptchaInput}
                onChange={(e) => setUserCaptchaInput(e.target.value)}
              />
              <div className="CaptchaBB">
                <button onClick={onCancel} className="CaptchaC ar TFut16PxPCUC">
                  إلغاء
                </button>
                <button onClick={onVerify} className="CaptchaV ar TFut16PxPCUC">
                  تحقق
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
